import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";


export default function CurrencyCreate() {
  const navigate = useNavigate();
  const language = useUserLanguage();
const { translations } = useTranslations(language);
const getText = (key, def) => translations[key] || def;


  const [form, setForm] = useState({
    code: "",
    symbol: "",
    name: "",
  });

  const handleChange = (e) => {
    let value = e.target.value;

    if (e.target.name === "decimal_places" || e.target.name === "is_default") {
      value = Number(value);
    }

    setForm({ ...form, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/currencies`,
      form
    );
    toast.success(getText("CURRENCY_CREATED_SUCCESS"));
    navigate("/currency/table");
  };

  return (
    <div className="container card p-4 mt-3">

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("CURRENCY_CODE_LABEL")}</label>
          <input
            className="form-control"
            placeholder={getText("CURRENCY_CODE_PLACEHOLDER")}
            name="code"
            value={form.code}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">{getText("CURRENCY_SYMBOL_LABEL")}</label>
          <input
            className="form-control"
            placeholder={getText("CURRENCY_SYMBOL_PLACEHOLDER")}
            name="symbol"
            value={form.symbol}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">{getText("CURRENCY_NAME_LABEL")}</label>
          <input
            className="form-control"
            placeholder={getText("CURRENCY_NAME_PLACEHOLDER")}
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-primary">
            {getText("SAVE")}
          </button>
        </div>
      </form>
    </div>
  );
}
